import Activity from '../../schema/Activity';
import CardRole from '../../schema/innerSchema/CardRole';

/**
 * This fucntion iterate through all the activities. Using the hash - it decide when to create a card
 * @primaryActivityCounts - a hash that represent how many primary activities are for each entityID (should be 1 or 2)
 * ### One primary activity for entity ###
 * it means that
 * 1) for this entity there is also a secondary card
 * OR
 * 2) it has only one primary card
 * it should set the cardRole to be combined and set the hash value to 0, so when the iteration will get to the secondary activity
 * it won't create new card for it.
 * ### Two primary activities for entity ###
 * it means that
 * it should create two cards and set the cardRole to be Primary for each
 */
export default function getCardRole(activityItem: Activity, primaryActivityCounts: any): CardRole {
    let entityId = activityItem.entityId;
    let primaryRoleCount = primaryActivityCounts[entityId];
    if (primaryRoleCount == 2) {
        return CardRole.Primary;
    } else if (primaryRoleCount == 1) {
        primaryActivityCounts[activityItem.entityId] = 0;
        return CardRole.Combined;
    } else {
        return null;
    }
}
